import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import api from "../../../service/api";

import Header from "../../../components/Header";
import ModalSuccess from "../../../components/ModalSuccessMessage";
import NavTabs from "../../../components/NavTabs";
import Checkbox from "../../../components/Checkbox";
import Select from "../../../components/Select";
import Button from "../../../components/Button";

import { SelectContainer, SelectLabel, Th, Tr, Td, AppName, ButtonContainer } from "./styles";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Data
import routes from "../../../routes/users.routes";
import accessData from "../../../data/accessConfig";

//Interfaces
import { GroupsInterface } from "./interfaces";

const Access = () => {
    const [groups, setGroups] = useState<Array<GroupsInterface>>([
        
    ]);
    const [selectedGroup, setSelectedGroup] = useState<any>({
        "id": "",
        "description": "",
        "cm1": false,
        "cm1u": false,
        "cm1r1": false,
        "cm1r2": false,
        "cm1e": false,
        "cm2": false,
        "cm2c": false,
        "cm2e": false,
        "cm2r": false,
        "cm2u": false,
        "cm2d": false,
        "cm3": false,
        "cm3a1": false,
        "cm3a2": false,
        "cm3a3": false,
        "cm4": false,
        "cm4a1": false,
        "cm4a2": false,
        "cm4a3": false,
        "cm5": false,
        "cm5a1": false,
        "cm5a1c": false,
        "cm5a1e": false,
        "cm5a1r": false,
        "cm5a1u": false,
        "cm5a1d": false,
        "cm5a2": false,
        "cm5a2c": false,
        "cm5a2e": false,
        "cm5a2r": false,
        "cm5a2u": false,
        "cm5a2d": false,
        "cm5a3": false,
        "cm6": false,
        "cm6a1": false,
        "cm6a1u": false,
        "cm6a2": false,
        "cm6a2c": false,
        "cm6a2u": false,
        "cm6a3": false,
        "cm6a3u1": false,
        "cm6a3u2": false,
        "cm6a4": false,
        "cm6a4c1": false,
        "cm6a4c2": false,
        "cm6a4c3": false,
        "cm6a5": false,
        "cm6a5u1": false,
        "cm6a5u2": false,
        "cm7": false,
        "cm7a1": false,
        "cm7a2": false,
        "cm8": false,
        "cm8a1": false,
        "cm8a2": false
    });

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    useEffect(() => {
        if(login.user.groups.am2a3){
            history.push("/admin/dashboard");
        }
    }, []);

    useEffect(() => {
        const getGroups = async () => {
            const {data} = await api.get("/adm/group");

            setGroups(data);
            setSelectedGroup(data[0]);
        }

        getGroups();
    }, []);

    const generateSelectOptions = () => {
        return groups.map(group => {
            return(
                <option key={`option_${group.id}`} value={group.id}>{group.description}</option>
            );
        });
    }

    const generateAccessOptionsList = () => {
        return accessData.map(row => {
            return (
                <Tr key={`tr_${row.id}`}>
                    <AppName>{row.description}</AppName>
                    <Td><Checkbox isChecked={selectedGroup[row.id]} disabled={login.user.groups.am2a3u} onClick={() => handleCheckboxChange(row.id)}/></Td>
                </Tr>
            )
        })
    }

    const handleSelectChange = (id: string) => {
        const group = groups.filter(value => value.id === id);

        setSelectedGroup(group[0]);
    }

    const handleCheckboxChange = (id: string) => {
        setSelectedGroup({...selectedGroup, [id]: !selectedGroup[id]});
    }

    const handleSaveConfig = async () => {
        try {
            const response = await api.put("/adm/group/update", {
                ...selectedGroup
            });

            openModal("exampleModal");
    
            const {data} = await api.get("/adm/group");
    
            setGroups(data);
        } catch (error) {
            
        }
    }

    return(
        <div>
            <Header title="Usuários" subTitle="Gerencie todos os usuários do sistema" subTitleWidth={174}/>
            <NavTabs tabs={routes}/>
            <ModalSuccess text="Regras de acesso alteradas com sucesso"/>
            <SelectContainer>
                <SelectLabel>Selecionar o grupo:</SelectLabel>
                <Select style={{marginBottom: 0, width: 187}} onChange={(e) => handleSelectChange(e.target.value)}>
                    {generateSelectOptions()}
                </Select>
            </SelectContainer>

            <table style={{width: "100%"}} className="table-responsive">
                <thead>
                    <tr>
                        <Th>Nome da aplicação</Th>
                        <Th>Acesso</Th>
                    </tr>
                </thead>
                <tbody>
                    {generateAccessOptionsList()}
                </tbody>

            </table>
            <ButtonContainer>
                <Button onClick={() => handleSaveConfig()}>Salvar Alterações</Button>
            </ButtonContainer>
        </div>
    )
}

export default Access;